export const GTM_ID = "GTM-K9C8KHQ7"

export const pageView = (url) => {
    window.dataLayer?.push({
        event: 'pageview',
        page: url,
    })
}